export default __webpack_public_path__ + "static/media/KYC.288ae538.png";